import type { FaireProductEntity } from "../../entity_types/product";

export const p_dpy9wbgpsq: FaireProductEntity = {
  token: "p_dpy9wbgpsq",
  type: "product",
  name: "Colombia Tolima Guava Banana Whole Bean Coffee",
  brandToken: "b_f358njub53",
  brandName: "Comeback",
  imageUrl: "https://cdn.faire.com/fastly/e0565954ecbd0651adda5d8f7df1624cdf33347877bce5e035e691ece1615c47.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f23a60e920baba69400bee1452e77b494f20b0d70aad678c4162a761b8175e0f.jpeg",
    "https://cdn.faire.com/fastly/e100ac9c264ca4710c097dbdff430da1480c4e3a0c033bb1907a4a560e6d7d78.jpeg",
    "https://cdn.faire.com/fastly/a670684572bcab758d9421a81f91770e551afeb85fcb506d020b2b0b8464b5e6.jpeg"
  ],
  priceDollars: 14,
  description: "**Currently Shipping in Off-White Tins \n\nSize: 10oz Retail Tin, 2lb Bags, 5lb Bags\nTaste Notes: Tropical Fruits, Dark Chocolate, Creamy\nCountry: Colombia\nLocation: Tolima\nElevation: 1650 MASL\nVariety: Red & Yellow Caturra \nProcessing: Natural Anaerobic\n\nThis Red & Yellow Caturra is one of the flagship coffees produced at El Vergel State, located in the micro lot next to the washing station, and surrounded by Guava trees, this coffee profile has been one of the most intense and fruity coffees developed by the estate. Planted in 2016 and 2018 with a quantity of more than 40.000 plants, this lot has been one of the best of the estate to experiment with processing bigger lots. ",
  tags: [],
  msrpDollars: 20.3,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:55.154Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
